{
  "view": {
    "title": "Förråd",
    "storageUnit": "Förråd",
    "reserve": "Reservera",
    "cancel": "Avbryt",
    "details": "Uppgifter",
    "description": "Här kan du se förrådsenheter och reservera ett eget förråd genom att klicka på önskad enhet.",
    "noStorageAreas": "Inga tillgängliga förrådsenheter",
    "noPermissions": "Inga reservationsrättigheter.",
    "acceptTerms": "Jag godkänner reglerna för {{address}} och reservationsvillkoren för förråd"
  },
  "startOption": {
    "today": "Idag"
  },
  "legend": {
    "available": "Ledig",
    "reservedOrInactive": "Reserverad",
    "mine": "Min reservation",
    "mineUpcoming": "Min kommande reservation",
    "notInUse": "Inte i bruk",
    "ending": "Upphör snart",
    "starting": "Börjar snart"
  },
  "success": {
    "title": "Förrådsreservation lyckades!",
    "description": "{{area}}, på adress {{address}}.",
    "starts": "Reservation börjar {{date}}"
  },
  "aria": {
    "availableIndicator": "Färgindikator för ledig enhet",
    "reservedIndicator": "Färgindikator för reserverad enhet",
    "mineIndicator": "Färgindikator för användarens egen reservation",
    "mineUpcomingIndicator": "Färgindikator för snart påbörjad egen reservation"
  },
  "price": {
    "label": "Pris",
    "perMonth": "{{amount}} / mån",
    "fromPerMonth": "från {{amount}} / mån"
  },
  "tooltip": {
    "reservation": {
      "current": { "label": "Reservation" },
      "future": { "label": "Kommande reservation" },
      "previous": { "label": "Tidigare reservation" }
    },
    "available": "Tillgänglig",
    "openEnded": "(tills vidare)"
  },
  "reservation": {
    "form": {
      "description": "Reservera förråd",
      "submit": "Reservera"
    },
    "success": {
      "title": "Förrådsreservation lyckades!",
      "description": "Förråd {{area}} reserverat från {{date}}",
      "starts": "Reservation börjar"
    }
  },
  "effectiveFrom": "Ändringen träder i kraft",
  "error": {
    "contractMissing": "Avtalsuppgifter saknas - reservation kan inte göras.",
    "reservationFailed": "Reservation misslyckades. Försök igen om en stund.",
    "overlap": "Valt startdatum är i konflikt med befintlig reservation. Välj ett annat datum eller avsluta nuvarande reservation.",
    "terminationFailed": "Uppsägning av reservation misslyckades. Försök igen om en stund.",
    "reservationStartBeforeContractStart": "Reservation kan inte börja före avtalets startdatum."
  },
  "terminate": {
    "form": {
      "description": "Säg upp förråd",
      "submit": "Säg upp"
    },
    "endDateLabel": "Ändringen träder i kraft",
    "futureReservationLabel": "Reservation träder i kraft",
    "cta": "Avboka reservation",
    "success": "Reservation avbokad",
    "cancelledTitle": "Förrådsreservation avbokad",
    "cancelledFrom": "Förråd {{area}} reservation har avbokats från {{date}}",
    "reservationStartedOn": "Bokningens startdatum: {{date}}"
  },
  "modal": {
    "rulesLink": "Regler",
    "termsLink": "Reservationsvillkor"
  },
  "extraService": {
    "myReservations": "Mina förrådsreservationer",
    "startDate": "Startdatum",
    "endDate": "Slutdatum",
    "openEnded": "Gäller tills vidare",
    "active": "Aktiv",
    "ending": "Upphör snart",
    "pincode": {
      "code": "Åtkomstkod: {{pincode}}",
      "loading": "Laddar åtkomstkod...",
      "loadError": "Laddning av åtkomstkod misslyckades"
    }
  }
}
